import React from "react";
import { connect } from "react-redux";

import Panel from "../core/components/panels/Panel";

import { IAppState } from "../core/state/Store";

import GeneralContainer from "../core/components/containers/GeneralContainer";
import { Alignment, Side } from "../core/types/system/Layout";
import Button from "../core/components/buttons/Button";
import ButtonThemes from "../core/types/enums/ButtonThemes";
import Toolbar from "../core/components/toolbar/Toolbar";
import Spacer from "../core/components/containers/Spacer";
import ProductSubscription from "../core/types/core/ProductSubscription";
import ButtonMenu from "../core/components/buttons/ButtonMenu";

import v10Icon from "../core/graphics/V10-Logo_1.png";

import "./Version10.scss";

interface RouteVersion10Props {
    productSubscriptions: ProductSubscription[];
}

interface RouteVersion10State {
    licenceCode?: string;
}

class RouteVersion10 extends React.Component<
    RouteVersion10Props,
    RouteVersion10State
> {
    state: RouteVersion10State = {};

    static getDerivedStateFromProps(
        props: RouteVersion10Props,
        state: RouteVersion10State,
    ): RouteVersion10State {
        const desktop = props.productSubscriptions.find(
            ps => ps.clientSystemName === "Desktop Client V10",
        );

        return {
            licenceCode: desktop?.licenceCode,
        };
    }

    lessonsClick() {
        (window as any)._elev.openArticle(734);
    }

    downloadExecutable() {
        window.open(
            "https://timetablingmainsite.blob.core.windows.net/releases/v10/TimetablingSolutionsV10.exe",
        );
    }

    downloadWindowsInstaller() {
        window.open(
            "https://timetablingmainsite.blob.core.windows.net/releases/v10/TimetablingSolutionsV10.msi",
        );
    }

    render() {
        return (
            <section>
                <GeneralContainer
                    scaling={true}
                    max={true}
                    bufferSide={Side.All}
                    alignment={Alignment.Center}>
                    <div className="top-clearance full row">
                        <img
                            src={v10Icon}
                            alt="Version 10 Icon"
                            style={{ width: "50px", height: "50px" }}
                        />
                        <span className="product-title">
                            Timetabling Solutions Version 10
                        </span>
                    </div>

                    <Panel
                        title="System Requirements"
                        size="large"
                        bufferSide={Side.All}
                        clearanceSide={Side.Top}>
                        <ul className="list">
                            <li>
                                Microsoft Windows 10 and 11 with Microsoft
                                Office 2016, Office 365
                            </li>
                            <li>Minimum 8 Gigabytes (GB) of RAM</li>
                            <li>
                                Minimum screen resolution of 1280 x 1024, we
                                recommend wide screens with 1920 x 1080
                            </li>
                            <li>
                                A keyboard, mouse or compatible pointing device
                            </li>
                            <li>
                                Date settings to be set to Australian (short
                                date style, dd/mm/yyyy)
                            </li>
                        </ul>

                        <Toolbar position={Side.Bottom}>
                            <Button
                                align={Alignment.Left}
                                text="Lesson Library"
                                onClick={this.lessonsClick.bind(this)}
                            />

                            <Spacer />

                            <ButtonMenu
                                align={Alignment.Right}
                                theme={ButtonThemes.Theme}
                                text="Download">
                                <Button
                                    text="Download Executable (.exe)"
                                    onClick={this.downloadExecutable.bind(this)}
                                />
                                <Button
                                    text="Download Windows Installer (.msi)"
                                    onClick={this.downloadWindowsInstaller.bind(
                                        this,
                                    )}
                                />
                            </ButtonMenu>
                        </Toolbar>
                    </Panel>

                    <Panel
                        title="User Access"
                        size="large"
                        clearanceSide={Side.Top}
                        bufferSide={Side.All}>
                        <p>
                            To publish timetables to our Web Daily Organiser
                            product, users will need to be added and assigned
                            roles on the [1] Manage Users screen
                        </p>
                        <p>
                            Users requiring timetable publishing must be
                            assigned the role of "Timetabler" in conjunction
                            with any other applicable roles
                        </p>
                        <Toolbar position={Side.Bottom}>
                            <Spacer />

                            <Button
                                align={Alignment.Right}
                                text="Role Information"
                            />
                        </Toolbar>
                    </Panel>
                </GeneralContainer>
            </section>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { productSubscription } = state.db;
    return {
        productSubscriptions: productSubscription.productSubscriptions,
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteVersion10);
